import type { Prototype } from "../prototype-types";

export const cristiWallacePrototypes: Prototype[] = [
  {
    id: "nux-business-type",
    name: "NUX Business Type",
    path: "/cw/nux/business-type",
    description:
      "New User Experience onboarding screen where retailers share their business type. Used to tailor product recommendations during signup.",
    owner: "Cristi",
    createdAt: "2025-12-08",
    lastUpdated: "2025-12-12",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/eb913fbef27e0488ff810aea3c915f18e282d49eb03cfd8526e77cf25247587d.png",
    creationTool: "cursor",
  },
  {
    id: "starter-collections",
    name: "Starter Collections",
    path: "/cw/starter-collections",
    description:
      "Curated collections browsing experience with tabbed navigation and a planning sidebar. Retailers can browse themed brand collections and build orders that meet brand minimums.",
    owner: "Cristi",
    createdAt: "2025-12-13",
    lastUpdated: "2026-01-05",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/4f5369703b2ef7c279ef62a67e7969701283dcfaff934c76e34d6b1aff5be5dc.png",
    creationTool: "cursor",
  },
  {
    id: "product-category-picker",
    name: "Product Category Picker",
    path: "/cw/product-category-picker",
    description:
      "Two-variant exploration of the product category selection screen in signup. Variant 1: inline expandable chips. Variant 2: accordion list with chips.",
    owner: "Cristi",
    createdAt: "2026-02-12",
    lastUpdated: "2026-02-12",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/60de0d832d9e0f1eb10ce22e3827c01e6546c2b0dfef83821b13b72f43cb97d3.png",
    creationTool: "cursor",
  },
];
